import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs/internal/Observable';
import { IDevice } from '../../../../../../../../libs/services';
import { DlgConfirmActionComponent } from '../dlg-confirm-action/dlg-confirm-action.component';

@Injectable({
  providedIn: 'root',
})
export class DlgConfirmActionService {
  constructor(public dialog: MatDialog) {}

  openDialog(deviceContract: IDevice, deviceAction: string): Observable<any> {
    const modalInstance = this.dialog.open(DlgConfirmActionComponent, {
      maxHeight: '400px',
      height: 'auto',
      width: 'auto',
      autoFocus: false,
      data: {
        deviceContract: deviceContract,
        deviceAction: deviceAction,
      },
    });

    return modalInstance.afterClosed();
  }
}
